import React from "react"
import $ from 'jquery'
import { SkillsConfig } from "../../constants"
import SkillsImg from '../../assets/img/Skills.jpg'

const Skills = () => {
    $(function() {
        function skillShow() {
            if ( window.scrollY >= $('#skills').offset().top - 500 ) {
                $('.skills-percent').css('transform', 'translateX(0)')
            }
        }
        $(window).on('scroll', () => {
            skillShow()
        })
        skillShow()
    })
    return (
        <section id="skills">
            <div className="skills-header">
                <h1 className="font-bold text-2xl text-primary text-center">My Skills</h1>
            </div>
            <div className="flex justify-around items-center mt-2">
                <div className="hidden sm:flex sm:w-1/2">
                    <img src={ SkillsImg } alt="Rudin Engineer"/>
                </div>
                <div className="sticky skills-container m-4 px-6 py-4 bg-light rounded-md w-full shadow-lg sm:w-1/2">
                    {/* <div className="w-5 h-5 rounded-full -top-1.5 -left-1.5 absolute bg-primary"></div> */}
                    <div className="overflow-x-hidden">
                        {
                            SkillsConfig.skiils.map((value, index) => (
                            <div className="sticky mt-3">
                                <div className="skills-title absolute -translate-y-3">
                                    <h1 className="font-semibold text-sm text-primary">{ value.title }</h1>
                                </div>
                                <div className="flex justify-between items-center gap-5">
                                    <div style={{ width: String(parseInt(value.percent) - 10) + '%' }} className='skills-percent h-1 -translate-x-[110%] bg-primary transition duration-500 ease-in-out'></div>
                                    <div className="skills-percent-number">
                                        <h1 className="text-primary font-semibold">{ value.percent }%</h1>
                                    </div>
                                </div>
                            </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Skills